// extracted by mini-css-extract-plugin
module.exports = {"container":"Setup2FA_container__1_gIU","formContainer":"Setup2FA_formContainer__3eTgG","back":"Setup2FA_back__1QAsp","form":"Setup2FA_form__2lZxf"};